"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _uuid = _interopRequireDefault(require("uuid"));

var _FormGroup = _interopRequireDefault(require("../FormGroup/FormGroup"));

var _Label = _interopRequireDefault(require("../Label/Label"));

var _FieldMessage = _interopRequireDefault(require("../FieldMessage/FieldMessage"));

var _HelpText = _interopRequireDefault(require("../HelpText/HelpText"));

var _Select = _interopRequireDefault(require("../Select/Select"));

var _excluded = ["children", "label", "hideLabel", "hasError", "helpText", "fieldMessage", "optionalText", "value", "className", "selectClassName", "size"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var propTypes = {
  /** Options inside the select. <br/>Use the option tag: `<option value="myValue">My Option</option>` */
  children: _propTypes.node.isRequired,

  /** Label text */
  label: _propTypes.string.isRequired,

  /** The component will generate an id for you.<br>
   * If you need to create your own, pass it in as a prop */
  id: _propTypes.string,

  /** Sets an option to be selected by default */
  value: _propTypes.string,

  /** Visually hide the label */
  hideLabel: _propTypes.bool,

  /** Visual presentation of an error in the input */
  hasError: _propTypes.bool,

  /** Help text below the input form field */
  helpText: _propTypes.string,

  /** Usually used for validation */
  fieldMessage: _propTypes.string,

  /** Text describing the input as optional */
  optionalText: _propTypes.string,

  /** The size */
  size: (0, _propTypes.oneOf)(['small', 'medium', 'large']),

  /** Add your own custom class names to the component */
  className: _propTypes.string,

  /** Add your own custom class names directly to the `select` inside the group*/
  selectClassName: _propTypes.string
};
var defaultProps = {
  size: 'medium'
};
/** The SelectGroup is a packaged component that includes a Select, a Label, a HelpText and a FieldMessage. Everything is wrapped in a FormGroup.
 * @visibleName Select Group
 * */

var SelectGroup = /*#__PURE__*/function (_Component) {
  _inherits(SelectGroup, _Component);

  var _super = _createSuper(SelectGroup);

  function SelectGroup(props) {
    var _this;

    _classCallCheck(this, SelectGroup);

    _this = _super.call(this, props);
    _this.selectId = props.id || "rds-select-".concat(_uuid.default.v4());
    _this.helpTextId = "rds-selectgroup-form-text-".concat(_uuid.default.v4());
    _this.fieldMessageId = "rds-selectgroup-fieldmessage-".concat(_uuid.default.v4());
    return _this;
  }

  _createClass(SelectGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          hideLabel = _this$props.hideLabel,
          hasError = _this$props.hasError,
          helpText = _this$props.helpText,
          fieldMessage = _this$props.fieldMessage,
          optionalText = _this$props.optionalText,
          value = _this$props.value,
          className = _this$props.className,
          selectClassName = _this$props.selectClassName,
          size = _this$props.size,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var formGroupClassNames = (0, _classnames.default)({
        'rds-form-group--danger': hasError
      }, className);
      /* Create the aria-describedby text based on what elements are present*/

      var ariaDescribedBy;

      if (fieldMessage && helpText) {
        ariaDescribedBy = "".concat(this.helpTextId, " ").concat(this.fieldMessageId);
      } else if (helpText) {
        ariaDescribedBy = this.helpTextId;
      } else if (fieldMessage) {
        ariaDescribedBy = this.fieldMessageId;
      } else {
        ariaDescribedBy = null;
      }

      return /*#__PURE__*/_react.default.createElement(_FormGroup.default, {
        className: formGroupClassNames
      }, /*#__PURE__*/_react.default.createElement(_Label.default, {
        htmlFor: this.selectId,
        hideLabel: hideLabel,
        labelText: label,
        optionalText: optionalText
      }), /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
        size: size,
        hasError: hasError,
        value: value,
        id: this.selectId,
        className: selectClassName
      }, ariaDescribedBy && {
        'aria-describedby': ariaDescribedBy
      }, rest), children), fieldMessage && /*#__PURE__*/_react.default.createElement(_FieldMessage.default, {
        text: fieldMessage,
        skin: hasError ? 'danger' : null,
        id: this.fieldMessageId
      }), helpText && /*#__PURE__*/_react.default.createElement(_HelpText.default, {
        text: helpText,
        id: this.helpTextId
      }));
    }
  }]);

  return SelectGroup;
}(_react.Component);

SelectGroup.propTypes = propTypes;
SelectGroup.defaultProps = defaultProps;
var _default = SelectGroup;
exports.default = _default;